import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import KolManagement from './pages/KolManagement';
import KolSubmissionForm from './pages/KolSubmissionForm';
import EmailBatch from './pages/EmailBatch';
import EmailCampaign from './pages/EmailCampaign';  // 修改为默认导入
import { useAppSelector, useAppDispatch } from './hooks/useAppDispatch';
import { RootState } from './store';
import { setUserFromToken } from './store/slices/authSlice';
import { getToken } from './utils/auth';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isLoading } = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    const token = getToken(); // 使用 getToken 获取 token
    if (token) {
      dispatch(setUserFromToken(token));
    }
  }, [dispatch]);

  // 等待登录状态加载完成再渲染 Routes，防止闪跳
  if (isLoading) {
    return <div>Loading app...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/submit-kol" element={<KolSubmissionForm />} />
      <Route
        path="/"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated} isLoading={isLoading}>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="kols" element={<KolManagement />} />
        <Route path="email-batch" element={<EmailBatch />} />
        <Route path="email-campaign" element={<EmailCampaign />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
